// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form#step-form-horizontal > div:last-child {
    text-align: right;
    /* padding-top: 2rem; */
  }
  
  form#step-form-horizontal .form-group .text-label {
    text-align: left;
    display: block;
    /* padding-top: 2rem; */
  }
  [data-primary="color_2"] .wizard > .steps li.current a {
    background-color: #6418c3;
  }
  [data-primary="color_2"] .wizard .skip-email a {
    color: #6418c3;
  }
  [data-primary="color_2"] .wizard > .actions li:not(.disabled) a {
    background-color: #6418c3;
  }
  
  .step-form-horizontal .wizard {
    padding-top: 3.5rem;
  }
  
  .step-form-horizontal .wizard .steps li {
    position: relative;
  }
  
  .step-form-horizontal .wizard .steps li.done a {
    text-align: center;
    background-color: #fff;
    color: #6e6e6e;
  }
  
  [data-theme-version="dark"] .step-form-horizontal .wizard .steps li.done a {
    background-color: #181f39;
    color: #7e7e7e;
  }
  
  .step-form-horizontal .wizard .steps li.done a:hover {
    text-align: center;
    background-color: #fff;
    color: #6e6e6e;
  }
  
  .step-form-horizontal .wizard .steps li.done a .number {
    color: #fff;
    background: #6418c3;
    border-color: transparent;
  }
  
  [data-theme-version="dark"]
    .step-form-horizontal
    .wizard
    .steps
    li.done
    a
    .number {
    border-color: #6418c3;
  }
  
  .step-form-horizontal .wizard .steps li.current a,
  .step-form-horizontal .wizard .steps li.disabled a {
    background-color: transparent;
    text-align: center;
    color: #fff;
  }
  
  .step-form-horizontal .wizard .steps li.current a:hover,
  .step-form-horizontal .wizard .steps li.current a:active,
  .step-form-horizontal .wizard .steps li.disabled a:hover,
  .step-form-horizontal .wizard .steps li.disabled a:active {
    background-color: transparent;
    color: #fff;
  }
  
  .step-form-horizontal .wizard .steps li.current a .number {
    color: #6418c3;
    background: #fff;
    border: 2px solid #6418c3;
  }
  
  .step-form-horizontal .wizard .steps li.disabled a .number {
    color: #6418c3;
  }
  
  .step-form-horizontal .wizard .steps li a {
    position: relative;
    z-index: 1;
  }
  
  @media (max-width: 767.98px) {
    .step-form-horizontal .wizard .steps li a {
      padding-left: 0;
      padding-right: 0;
      margin: 0;
    }
  }
  
  @media (max-width: 575.98px) {
    .step-form-horizontal .wizard .steps li a {
      font-size: 0.75rem;
      padding-top: 0.9375rem;
    }
  }
  
  .step-form-horizontal .wizard .steps li a .number {
    position: absolute;
    top: -55px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #fff;
    border: 3px solid #d7dae3;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3rem;
    border-radius: 50px;
    width: 3rem;
  }
  
  [data-theme-version="dark"] .step-form-horizontal .wizard .steps li a .number {
    background: #181f39;
    border-color: #333a54;
  }
  
  @media only screen and (max-width: 575px) {
    .step-form-horizontal .wizard .steps li a .number {
      top: -45px;
    }
  }
  
  .step-form-horizontal .wizard .steps li:not(:last-child) {
    z-index: 1;
  }
  
  .step-form-horizontal .wizard .steps li:not(:last-child)::after {
    position: absolute;
    width: 100%;
    height: 0.375rem;
    content: "";
    left: 50%;
    top: -2.1rem;
    background-color: #6418c3;
    z-index: -1;
  }
  
  @media (max-width: 575.98px) {
    .step-form-horizontal .wizard .steps li:not(:last-child)::after {
      height: 0.375rem;
      top: -1.3125rem;
    }
  }
  
  .step-form-horizontal .wizard .steps li:not(:last-child).current::after {
    background-color: #f3f3f3;
  }
  
  [data-theme-version="dark"]
    .step-form-horizontal
    .wizard
    .steps
    li:not(:last-child).current::after {
    background: #181f39;
  }
  
  .step-form-horizontal .wizard .steps li:not(:last-child).current ~ li::after {
    background-color: #f3f3f3;
  }
  
  [data-theme-version="dark"]
    .step-form-horizontal
    .wizard
    .steps
    li:not(:last-child).current
    ~ li::after {
    background: #181f39;
  }
  
  .step-form-horizontal .wizard .actions {
    padding: 0;
  }
  
  @media only screen and (max-width: 575px) {
    .step-form-horizontal .wizard .actions {
      padding: 0;
    }
  }
  
  .step-form-horizontal ol {
    position: relative;
    display: flex !important;
    justify-content: space-between;
  }
  
  .step-form-horizontal ol li {
    position: relative;
    border: 0;
    margin-bottom: 0;
    background: transparent !important;
    z-index: 2;
    padding: 0 !important;
    width: 33.33%;
  }
  
  .step-form-horizontal ol li:after {
    content: none !important;
  }
  
  .step-form-horizontal ol li:before {
    content: "";
    height: 3px;
    width: 0;
    left: 0;
    top: 23px;
    position: absolute;
    background: #6418c3;
    transition: all 0.5s;
    z-index: 1;
  }
  
  .step-form-horizontal ol li.go767851704 {
    text-align: center;
    background-color: #fff;
    color: #6e6e6e;
  }
  
  .step-form-horizontal ol li.go767851704:before {
    width: 100%;
  }
  
  [data-theme-version="dark"] .step-form-horizontal ol li.go767851704 {
    background-color: #181f39;
    color: #7e7e7e;
  }
  
  .step-form-horizontal ol li.go767851704:hover {
    text-align: center;
    background-color: #fff;
    color: #6e6e6e;
  }
  
  .step-form-horizontal ol li.go767851704 span {
    color: #fff;
    background: #6418c3;
    border-color: transparent;
  }
  
  [data-theme-version="dark"] .step-form-horizontal ol li.go767851704 span {
    border-color: #6418c3;
  }
  
  .step-form-horizontal ol li.active,
  .step-form-horizontal ol li.go2478912419,
  .step-form-horizontal ol li.disabled {
    background-color: transparent;
    text-align: center;
    color: #fff;
    border: 0;
  }
  
  .step-form-horizontal ol li.active:hover,
  .step-form-horizontal ol li.active:active,
  .step-form-horizontal ol li.go2478912419:hover,
  .step-form-horizontal ol li.go2478912419:active,
  .step-form-horizontal ol li.disabled:hover,
  .step-form-horizontal ol li.disabled:active {
    background-color: transparent;
    color: #fff;
  }
  
  .step-form-horizontal ol li.active span,
  .step-form-horizontal ol li.go2478912419 span {
    color: #6418c3;
    background: #fff;
    border: 2px solid #6418c3;
  }
  
  .step-form-horizontal ol li.disabled span {
    color: #6418c3;
  }
  
  @media (max-width: 767.98px) {
    .step-form-horizontal ol li {
      padding-left: 0;
      padding-right: 0;
      margin: 0;
    }
  }
  
  @media (max-width: 575.98px) {
    .step-form-horizontal ol li {
      font-size: 0.75rem;
      padding-top: 0.9375rem;
    }
  }
  
  .step-form-horizontal ol li span {
    position: relative;
    background-color: #fff;
    border: 3px solid #d7dae3;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 3rem;
    border-radius: 50px;
    width: 3rem;
    padding: 0 !important;
    box-shadow: 0 0 0 3px #fff;
    z-index: 2;
    position: relative;
  }
  
  [data-theme-version="dark"] .step-form-horizontal ol li span {
    background: #181f39;
    border-color: #333a54;
  }
  
  .step-form-horizontal ol li:last-child {
    width: auto;
  }
  
  .step-form-horizontal ol::after {
    position: absolute;
    width: 100%;
    height: 4px;
    content: "";
    left: 0;
    top: 23px;
    background-color: #eee;
    z-index: 1;
  }
  
  .step-form-horizontal .actions {
    padding: 0;
  }
  
  @media only screen and (max-width: 575px) {
    .step-form-horizontal .actions {
      padding: 0;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/jsx/step.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;;;;;;;IAOE,qBAAqB;EACvB;;EAEA;;IAEE,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;EACb;;EAEA;;;;IAIE,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE;MACE,eAAe;MACf,gBAAgB;MAChB,SAAS;IACX;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,sBAAsB;IACxB;EACF;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IAET,2BAA2B;IAC3B,sBAAsB;IACtB,yBAAyB;IAGzB,aAAa;IAGb,uBAAuB;IAGvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE;MACE,gBAAgB;MAChB,eAAe;IACjB;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;;;;IAKE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;;;;;IAME,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;IACZ;EACF;;EAEA;IACE,kBAAkB;IAGlB,wBAAwB;IAGxB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,kCAAkC;IAClC,UAAU;IACV,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,QAAQ;IACR,OAAO;IACP,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IAEnB,oBAAoB;IACpB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;;IAGE,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;;EAEA;;;;;;IAME,6BAA6B;IAC7B,WAAW;EACb;;EAEA;;IAEE,cAAc;IACd,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE;MACE,eAAe;MACf,gBAAgB;MAChB,SAAS;IACX;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,sBAAsB;IACxB;EACF;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;IAGzB,aAAa;IAGb,uBAAuB;IAGvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IAErB,0BAA0B;IAC1B,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;IACX,OAAO;IACP,SAAS;IACT,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;MACE,UAAU;IACZ;EACF","sourcesContent":["form#step-form-horizontal > div:last-child {\n    text-align: right;\n    /* padding-top: 2rem; */\n  }\n  \n  form#step-form-horizontal .form-group .text-label {\n    text-align: left;\n    display: block;\n    /* padding-top: 2rem; */\n  }\n  [data-primary=\"color_2\"] .wizard > .steps li.current a {\n    background-color: #6418c3;\n  }\n  [data-primary=\"color_2\"] .wizard .skip-email a {\n    color: #6418c3;\n  }\n  [data-primary=\"color_2\"] .wizard > .actions li:not(.disabled) a {\n    background-color: #6418c3;\n  }\n  \n  .step-form-horizontal .wizard {\n    padding-top: 3.5rem;\n  }\n  \n  .step-form-horizontal .wizard .steps li {\n    position: relative;\n  }\n  \n  .step-form-horizontal .wizard .steps li.done a {\n    text-align: center;\n    background-color: #fff;\n    color: #6e6e6e;\n  }\n  \n  [data-theme-version=\"dark\"] .step-form-horizontal .wizard .steps li.done a {\n    background-color: #181f39;\n    color: #7e7e7e;\n  }\n  \n  .step-form-horizontal .wizard .steps li.done a:hover {\n    text-align: center;\n    background-color: #fff;\n    color: #6e6e6e;\n  }\n  \n  .step-form-horizontal .wizard .steps li.done a .number {\n    color: #fff;\n    background: #6418c3;\n    border-color: transparent;\n  }\n  \n  [data-theme-version=\"dark\"]\n    .step-form-horizontal\n    .wizard\n    .steps\n    li.done\n    a\n    .number {\n    border-color: #6418c3;\n  }\n  \n  .step-form-horizontal .wizard .steps li.current a,\n  .step-form-horizontal .wizard .steps li.disabled a {\n    background-color: transparent;\n    text-align: center;\n    color: #fff;\n  }\n  \n  .step-form-horizontal .wizard .steps li.current a:hover,\n  .step-form-horizontal .wizard .steps li.current a:active,\n  .step-form-horizontal .wizard .steps li.disabled a:hover,\n  .step-form-horizontal .wizard .steps li.disabled a:active {\n    background-color: transparent;\n    color: #fff;\n  }\n  \n  .step-form-horizontal .wizard .steps li.current a .number {\n    color: #6418c3;\n    background: #fff;\n    border: 2px solid #6418c3;\n  }\n  \n  .step-form-horizontal .wizard .steps li.disabled a .number {\n    color: #6418c3;\n  }\n  \n  .step-form-horizontal .wizard .steps li a {\n    position: relative;\n    z-index: 1;\n  }\n  \n  @media (max-width: 767.98px) {\n    .step-form-horizontal .wizard .steps li a {\n      padding-left: 0;\n      padding-right: 0;\n      margin: 0;\n    }\n  }\n  \n  @media (max-width: 575.98px) {\n    .step-form-horizontal .wizard .steps li a {\n      font-size: 0.75rem;\n      padding-top: 0.9375rem;\n    }\n  }\n  \n  .step-form-horizontal .wizard .steps li a .number {\n    position: absolute;\n    top: -55px;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    background-color: #fff;\n    border: 3px solid #d7dae3;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 3rem;\n    border-radius: 50px;\n    width: 3rem;\n  }\n  \n  [data-theme-version=\"dark\"] .step-form-horizontal .wizard .steps li a .number {\n    background: #181f39;\n    border-color: #333a54;\n  }\n  \n  @media only screen and (max-width: 575px) {\n    .step-form-horizontal .wizard .steps li a .number {\n      top: -45px;\n    }\n  }\n  \n  .step-form-horizontal .wizard .steps li:not(:last-child) {\n    z-index: 1;\n  }\n  \n  .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n    position: absolute;\n    width: 100%;\n    height: 0.375rem;\n    content: \"\";\n    left: 50%;\n    top: -2.1rem;\n    background-color: #6418c3;\n    z-index: -1;\n  }\n  \n  @media (max-width: 575.98px) {\n    .step-form-horizontal .wizard .steps li:not(:last-child)::after {\n      height: 0.375rem;\n      top: -1.3125rem;\n    }\n  }\n  \n  .step-form-horizontal .wizard .steps li:not(:last-child).current::after {\n    background-color: #f3f3f3;\n  }\n  \n  [data-theme-version=\"dark\"]\n    .step-form-horizontal\n    .wizard\n    .steps\n    li:not(:last-child).current::after {\n    background: #181f39;\n  }\n  \n  .step-form-horizontal .wizard .steps li:not(:last-child).current ~ li::after {\n    background-color: #f3f3f3;\n  }\n  \n  [data-theme-version=\"dark\"]\n    .step-form-horizontal\n    .wizard\n    .steps\n    li:not(:last-child).current\n    ~ li::after {\n    background: #181f39;\n  }\n  \n  .step-form-horizontal .wizard .actions {\n    padding: 0;\n  }\n  \n  @media only screen and (max-width: 575px) {\n    .step-form-horizontal .wizard .actions {\n      padding: 0;\n    }\n  }\n  \n  .step-form-horizontal ol {\n    position: relative;\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n  }\n  \n  .step-form-horizontal ol li {\n    position: relative;\n    border: 0;\n    margin-bottom: 0;\n    background: transparent !important;\n    z-index: 2;\n    padding: 0 !important;\n    width: 33.33%;\n  }\n  \n  .step-form-horizontal ol li:after {\n    content: none !important;\n  }\n  \n  .step-form-horizontal ol li:before {\n    content: \"\";\n    height: 3px;\n    width: 0;\n    left: 0;\n    top: 23px;\n    position: absolute;\n    background: #6418c3;\n    -webkit-transition: all 0.5s;\n    transition: all 0.5s;\n    z-index: 1;\n  }\n  \n  .step-form-horizontal ol li.go767851704 {\n    text-align: center;\n    background-color: #fff;\n    color: #6e6e6e;\n  }\n  \n  .step-form-horizontal ol li.go767851704:before {\n    width: 100%;\n  }\n  \n  [data-theme-version=\"dark\"] .step-form-horizontal ol li.go767851704 {\n    background-color: #181f39;\n    color: #7e7e7e;\n  }\n  \n  .step-form-horizontal ol li.go767851704:hover {\n    text-align: center;\n    background-color: #fff;\n    color: #6e6e6e;\n  }\n  \n  .step-form-horizontal ol li.go767851704 span {\n    color: #fff;\n    background: #6418c3;\n    border-color: transparent;\n  }\n  \n  [data-theme-version=\"dark\"] .step-form-horizontal ol li.go767851704 span {\n    border-color: #6418c3;\n  }\n  \n  .step-form-horizontal ol li.active,\n  .step-form-horizontal ol li.go2478912419,\n  .step-form-horizontal ol li.disabled {\n    background-color: transparent;\n    text-align: center;\n    color: #fff;\n    border: 0;\n  }\n  \n  .step-form-horizontal ol li.active:hover,\n  .step-form-horizontal ol li.active:active,\n  .step-form-horizontal ol li.go2478912419:hover,\n  .step-form-horizontal ol li.go2478912419:active,\n  .step-form-horizontal ol li.disabled:hover,\n  .step-form-horizontal ol li.disabled:active {\n    background-color: transparent;\n    color: #fff;\n  }\n  \n  .step-form-horizontal ol li.active span,\n  .step-form-horizontal ol li.go2478912419 span {\n    color: #6418c3;\n    background: #fff;\n    border: 2px solid #6418c3;\n  }\n  \n  .step-form-horizontal ol li.disabled span {\n    color: #6418c3;\n  }\n  \n  @media (max-width: 767.98px) {\n    .step-form-horizontal ol li {\n      padding-left: 0;\n      padding-right: 0;\n      margin: 0;\n    }\n  }\n  \n  @media (max-width: 575.98px) {\n    .step-form-horizontal ol li {\n      font-size: 0.75rem;\n      padding-top: 0.9375rem;\n    }\n  }\n  \n  .step-form-horizontal ol li span {\n    position: relative;\n    background-color: #fff;\n    border: 3px solid #d7dae3;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    height: 3rem;\n    border-radius: 50px;\n    width: 3rem;\n    padding: 0 !important;\n    -webkit-box-shadow: 0 0 0 3px #fff;\n    box-shadow: 0 0 0 3px #fff;\n    z-index: 2;\n    position: relative;\n  }\n  \n  [data-theme-version=\"dark\"] .step-form-horizontal ol li span {\n    background: #181f39;\n    border-color: #333a54;\n  }\n  \n  .step-form-horizontal ol li:last-child {\n    width: auto;\n  }\n  \n  .step-form-horizontal ol::after {\n    position: absolute;\n    width: 100%;\n    height: 4px;\n    content: \"\";\n    left: 0;\n    top: 23px;\n    background-color: #eee;\n    z-index: 1;\n  }\n  \n  .step-form-horizontal .actions {\n    padding: 0;\n  }\n  \n  @media only screen and (max-width: 575px) {\n    .step-form-horizontal .actions {\n      padding: 0;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
